import { render, staticRenderFns } from "./SubmerchantFragment.vue?vue&type=template&id=96cceef4&"
import script from "./SubmerchantFragment.vue?vue&type=script&lang=js&"
export * from "./SubmerchantFragment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports